
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  h1: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    letterSpacing: '-0.03em',
    lineHeight: 1.15,
    scrollMarginTop: theme.spacing(10)
  },
  h2: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    letterSpacing: '-0.02em',
    lineHeight: 1.2,
    scrollMarginTop: theme.spacing(10)
  },
  h3: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    lineHeight: 1.25,
    scrollMarginTop: theme.spacing(10)
  },
  h4: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1.5),
    fontWeight: 700,
    lineHeight: 1.3,
    scrollMarginTop: theme.spacing(10)
  },
  h5: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    fontWeight: 700,
    lineHeight: 1.35,
    scrollMarginTop: theme.spacing(10)
  },
  h6: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    fontWeight: 700,
    lineHeight: 1.4,
    scrollMarginTop: theme.spacing(10)
  }
}));

function Heading({
  children,
  variant,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Typography
      className={classes[variant]}
      variant={variant}
      color="textPrimary"
      {...rest}
    >
      {children}
    </Typography>
  );
}

Heading.propTypes = {
  children: PropTypes.any,
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
};


export default Heading;
